/**
 * Curated set of lucide icons available for roadmap entries. The DB stores the
 * string key (e.g. "MessageSquare"); both the admin picker and the public
 * landing resolve it through ROADMAP_ICONS. Unknown keys fall back to Sparkles.
 */
import {
  Sparkles,
  MessageSquare,
  Users,
  BarChart3,
  Calendar,
  Image,
  Video,
  Bot,
  Zap,
  Globe,
  Bell,
  Heart,
  Star,
  Rocket,
  ShoppingCart,
  Mail,
  Link as LinkIcon,
  TrendingUp,
  Palette,
  Lock,
  Smartphone,
  Clock,
  FileText,
  Layers,
  Hash,
  Send,
  type LucideIcon,
} from 'lucide-react';

export const ROADMAP_ICONS: Record<string, LucideIcon> = {
  Sparkles,
  MessageSquare,
  Users,
  BarChart3,
  Calendar,
  Image,
  Video,
  Bot,
  Zap,
  Globe,
  Bell,
  Heart,
  Star,
  Rocket,
  ShoppingCart,
  Mail,
  Link: LinkIcon,
  TrendingUp,
  Palette,
  Lock,
  Smartphone,
  Clock,
  FileText,
  Layers,
  Hash,
  Send,
};

/** Stable list of icon keys for the admin picker grid. */
export const ROADMAP_ICON_KEYS = Object.keys(ROADMAP_ICONS);

/** Resolve a stored icon key to a component, falling back to Sparkles. */
export function roadmapIcon(key: string | null | undefined): LucideIcon {
  return (key && ROADMAP_ICONS[key]) || Sparkles;
}
